'use client';

import { getCookie } from 'cookies-next';
import { useState, useEffect } from 'react';

import { Loading } from 'components/Loading';
import { TOPSORT_USER_ID } from 'constants/browserStorageNames';
import {
  getTopsortBanner,
  TopsortBannerData
} from 'services/topsort/getTopsortBanner';
import { browserLogger } from 'utils/logger/browserLogger';
import ArrowUpRight from 'assets/icons/ic-arrow-up-right.svg';
import { isMobile as getIsMobile } from 'utils/misc';

import * as styles from './BannerTopsort.css';

export default function BannerTopsort({ idBanner }: { idBanner: string }) {
  const [isLoading, setIsLoading] = useState(true);
  const [banner, setBanner] = useState<TopsortBannerData | null>(null);
  const topsortUserId = getCookie(TOPSORT_USER_ID);

  const fetchBanner = async (isMobile: boolean) => {
    try {
      const bannerData = await getTopsortBanner(idBanner, isMobile);
      if (bannerData) {
        setBanner(bannerData);
      } else {
        setBanner(null);
      }
    } catch (error) {
      browserLogger().error({
        message: 'Topsort Auction error',
        data: String(error)
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const isMobile = getIsMobile();
    fetchBanner(isMobile);
  }, [idBanner, topsortUserId]);

  if (isLoading) {
    return <Loading />;
  }

  if (!banner) {
    return null;
  }

  return (
    <div
      data-ts-resolved-bid={banner.resolvedBidId}
      data-ts-clickable
      className={styles.ContainerBase}
      data-testid={`topsort-banner-${idBanner}`}
    >
      <a
        href={banner.url}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.TopsortLink}
      >
        <img
          data-testid={`topsort-banner-img-${idBanner}`}
          src={banner.imageUrl}
          alt={`Banner ADS ${idBanner}`}
          className={styles.TopsortImg}
        />

        <div className={styles.topsortTag}>
          <span>Publicidade</span>
          <ArrowUpRight width={12} height={12} className={styles.topsortTagIcon} />
        </div>
      </a>
    </div>
  );
}
